import * as _ from "lodash";
import { ModelTermBO } from "./ModelTermBO";
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { ModelBO } from "./ModelBO";
import {
    WB_ModelCannibalizationRelationshipRow,
    WB_ModelPredictorRelationshipRow,
    WB_ModelPredictorRow,
    WB_ModelProfileGroupPredictorRow,
    WB_ModelProfileGroupRow,
    WB_ModelProfilePredictorRow,
    WB_ModelProfileRow,
    WB_ModelProfileSpendFunctionRow,
    WB_ModelRow,
    WB_ModelTermRelationshipRow,
    WB_ModelVolumeComponentItemRow,
    WB_ModelVolumeComponentRelationshipRow,
    WB_PowerMetricRelationshipRow,
    WB_PowerMetricRow
} from "../PA.Core/PAdbSchemaRows";
import {
    esWB_AffinityGroup,
    esWB_Model_Profile_Spend_Function,
    esWB_Power_Metric_Relationship,
    esWB_Spend_Function
} from "../PA.Core/PAdbSchema";
import { CustomerBO } from "../PA.MD.BusinessObjects/CustomerBO";
import { PASearch } from "../PA.Core/PASearch";

export class ModelBOValidations {
    static Validation(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            ModelBOValidations.ValidateEmptyFields(aBO)
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidateResidualMethod(aBO);
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidateCannibalization(aBO);
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidateModelFormula(aBO);
                })
                .then(() => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidatePredictorMetaMappings(aBO);
                })
                .then(() => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidateModelProfiles(aBO);
                })
                .then(() => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    return ModelBOValidations.ValidatePredictorGroups(aBO);
                })
                .then((ignore) => {
                    if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                        resolve();
                        return;
                    }

                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        });
    }

    static async ValidateEmptyFields(aBO: ModelBO): Promise<void> {
        // return new Promise<void>((resolve, error) => {
        if (_.isEmpty(aBO.WB_Model.cif.MODEL_ID)) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "modelid",
                title: "Model ID cannot be empty",
                description: "",
                subtitle: "",
                count: 0
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("modelid");
        }
        if (_.isEmpty(aBO.WB_Model.cif.MODEL_NAME)) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "modelname",
                title: "Model Name cannot be empty",
                description: "",
                subtitle: "",
                count: 0
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("modelName");
        }

        if (_.isEmpty(aBO.WB_Model.cif.MODEL_TYPE)) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "modeltype",
                title: "Model Type cannot be empty",
                description: "",
                subtitle: "",
                count: 0
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("modeltype");
        }

        // Group Predictors
        let predictors: WB_ModelProfilePredictorRow[] = [];
        let groupPredictors: WB_ModelProfileGroupPredictorRow[] = [];
        let groups: any[] = [];
        let groupNameEmpty = 0;
        const dctVCPredictors = aBO.getVolumeComponentFirstObservedPredictors();
        const mdlEvtTypes = _.filter(aBO.WB_Model.WB_ModelEventTypeRelationshipRows, (a) => a.isActive);
        const dctEvtTypes = _.keyBy(mdlEvtTypes, (et) => et.cif.WB_MODEL_EVTTYPER_ID);

        _.forEach(aBO.WB_Model.WB_ModelProfileRows, (aRow) => {
            if (aRow.isActive) {
                const evtType = dctEvtTypes[aRow.cif.WB_MODEL_EVTTYPER_ID];
                const arrPredictors = dctVCPredictors[evtType?.cif?.WB_MODEL_VOLUME_COMPONENT_ID] || [];
                if (arrPredictors.length > 0) {
                    _.forEach(aRow.WB_ModelProfilePredictorRows, (pre) => {
                    if (pre.isActive && pre.cif.INPUT_METHOD == "UserEntered" && _.includes(_.map(arrPredictors, "WB_MODEL_PREDICTOR_ID"), pre.cif.WB_MODEL_PREDICTOR_ID)) predictors.push(pre);
                    });
                }

                _.forEach(aRow.WB_ModelProfileGroupRows, (profileGroup: WB_ModelProfileGroupRow) => {
                    if (profileGroup.isActive) {
                        groups.push(profileGroup);
                        if (_.isEmpty(profileGroup.cif.GROUP_NAME)) {
                            groupNameEmpty++;
                        }
                        _.forEach(
                            profileGroup.WB_ModelProfileGroupPredictorRows,
                            (predictorRows: WB_ModelProfileGroupPredictorRow) => {
                                if (predictorRows.isActive) {
                                    groupPredictors.push(predictorRows);
                                }
                            }
                        );
                    }
                });
                if (
                    predictors.length > 0 &&
                    groups.length > 0 &&
                    (groupPredictors.length == 0 || predictors.length != groupPredictors.length)
                ) {
                    let missingPredictors: string[] = [];
                    if (groupPredictors.length == 0 && groups.length > 0) {
                        missingPredictors = _.map(predictors, (a) => a.WB_ModelPredictorRow.cif.MODEL_PREDICTOR_NAME);
                    } else {
                        const predictorNames = _.map(predictors, (a) => a.WB_ModelPredictorRow.cif.MODEL_PREDICTOR_NAME);
                        const groupPredictorNames = _.map(
                            groupPredictors,
                            (a) => a.WB_ModelPredictorRow.cif.MODEL_PREDICTOR_NAME
                        );
                        _.forEach(predictorNames, (aPredictor) => {
                            if (!groupPredictorNames.includes(aPredictor)) missingPredictors.push(aPredictor);
                        });
                    }
                    const aSet = new Set(missingPredictors);
                    missingPredictors = [...aSet];
                    if (missingPredictors.length > 0)
                        aBO.ValidateMessageProvider.addMessage({
                            type: MessageType.Error,
                            code: "groupPredictor",
                            title:
                                "Profile '" +
                                aRow.cif.PROFILE_NAME +
                                "': Please add all Predictors to the Groups. Missing Predictors: " +
                                missingPredictors.join(","),
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                    else {
                        aBO.ValidateMessageProvider.removeMessage("groupPredictor");
                    }
                }
            }
            predictors = [];
            groups = [];
            groupPredictors = [];
        });

        if (groupNameEmpty > 0)
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "groupName",
                title: "Please make sure all created groups have been named.",
                description: "",
                subtitle: "",
                count: 0
            });
        else {
            aBO.ValidateMessageProvider.removeMessage("groupName");
        }

        //Validate if Group has Widget Type assigned or not
        let emptyWidgetCount = 0;

        _.forEach(aBO.WB_Model.WB_ModelProfileRows, (profile: WB_ModelProfileRow) => {
            if (!profile.isActive)
                return;
            if (profile.cif.PROFILE_TYPE != "Optimizer")
                return;

            _.forEach(profile.WB_ModelProfileGroupRows, (group: WB_ModelProfileGroupRow) => {
                if (
                    group.isActive &&
                    (group.cif.WIDGET_TYPE == "" || group.cif.WIDGET_TYPE == "HyperRectangle")
                ) {
                    emptyWidgetCount++;
                }
            });

        });

        if (emptyWidgetCount > 0) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "emptyWidgetCount",
                title: "Group/Predictor tab: Please make sure all groups have an assigned widget type  ",
                description: "",
                subtitle: "",
                count: 0
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("emptyWidgetCount");
        }

        //Validate Spend/Shipment Functions selected between Optimizer config and Simulation config
        const selectedSpendFunction: number[] = [];
        const selectedShipmentFunctions: number[] = [];
        const selectedSimSpendFunction: number[] = [];
        const selectedSimShipmentFunctions: number[] = [];

        let selectedSimProfile = _.filter(aBO.WB_Model.WB_ModelProfileRows, (aRow) => {
            if (aRow.isActive && aRow.cif.WB_MODEL_PROFILE_ID_PRM > 0 && aRow.cif.PROFILE_TYPE == "Optimizer")
                return aRow.cif.WB_MODEL_PROFILE_ID_PRM;
        });
        selectedSimProfile = _.map(selectedSimProfile, "WB_MODEL_PROFILE_ID_PRM");

        for (const profile of aBO.WB_Model.WB_ModelProfileRows) {
            if (
                profile.isActive &&
                profile.cif.WB_MODEL_PROFILE_ID_PRM > 0 &&
                profile.cif.PROFILE_TYPE == "Optimizer"
            ) {
                for (const spendFunction of profile.WB_ModelProfileSpendFunctionRows) {
                    if (spendFunction.isActive && spendFunction.cif.INCLUDE_IND == "1") {
                        //get spend function type
                        const functionRow = await aBO.dbContext.find(
                            esWB_Spend_Function,
                            spendFunction.cif.WB_SPEND_FUNCTION_ID
                        );
                        if (functionRow.isActive) {
                            if (functionRow.cif.FUNCTION_TYPE == "Spend")
                                selectedSpendFunction.push(functionRow.cif.WB_SPEND_FUNCTION_ID);
                            else if (functionRow.cif.FUNCTION_TYPE == "Shipment")
                                selectedShipmentFunctions.push(functionRow.cif.WB_SPEND_FUNCTION_ID);
                        }
                    }
                }
            } else {
                //Simulation Spend/Shipments functions selected
                if (selectedSimProfile.includes(profile.cif.WB_MODEL_PROFILE_ID)) {
                    for (const spendFunction of profile.WB_ModelProfileSpendFunctionRows) {
                        if (spendFunction.isActive && spendFunction.cif.INCLUDE_IND == "1") {
                            const functionRow = await aBO.dbContext.find(
                                esWB_Spend_Function,
                                spendFunction.cif.WB_SPEND_FUNCTION_ID
                            );
                            if (functionRow.isActive) {
                                if (functionRow.cif.FUNCTION_TYPE == "Spend")
                                    selectedSimSpendFunction.push(functionRow.cif.WB_SPEND_FUNCTION_ID);
                                else if (functionRow.cif.FUNCTION_TYPE == "Shipment")
                                    selectedSimShipmentFunctions.push(functionRow.cif.WB_SPEND_FUNCTION_ID);
                            }
                        }
                    }
                }
            }
        }

        if (
            !selectedSpendFunction.every((val) => selectedSimSpendFunction.includes(val)) &&
            !selectedShipmentFunctions.every((val) => selectedSimShipmentFunctions.includes(val))
        ) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Warning,
                code: "spendShip",
                title: "Warning: One or more of your spend/shipment functions are not included in the Promo Simulation profile you selected. Please Update. ",
                description: "",
                subtitle: "",
                count: 0
            });
        } else if (!selectedSpendFunction.every((val) => selectedSimSpendFunction.includes(val))) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Warning,
                code: "spend",
                title: "Warning: One or more of your spend functions are not included in the Promo Simulation profile you selected. Please Update. ",
                description: "",
                subtitle: "",
                count: 0
            });
        } else if (!selectedShipmentFunctions.every((val) => selectedSimShipmentFunctions.includes(val))) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Warning,
                code: "ship",
                title: "Warning: One or more of your shipment functions are not included in the Promo Simulation profile you selected. Please Update. ",
                description: "",
                subtitle: "",
                count: 0
            });
        }

        //Validate the Cann Type - Power Metrics - Predictors to the Core Volume Formula
        async function validatePowerMetric() {
            const arrCoreVolumePredictors = _.keyBy(
                _.filter(
                    aBO.WB_Model.WB_ModelPredictorRelationshipRows,
                    (aPredRelRow: WB_ModelPredictorRelationshipRow) => aPredRelRow.isActive
                ),
                "WB_MODEL_PREDICTOR_ID"
            );

            const invalidPowerMetrics: string[] = [];

            for (const aRow of aBO.WB_Model.WB_ModelCannibalizationRelationshipRows) {
                if (aRow.isActive) {
                    const powerMetricRow: WB_PowerMetricRow = aRow.WB_PowerMetricRow;
                    if (!_.isUndefined(powerMetricRow)) {
                        const powerMetricRels: WB_PowerMetricRelationshipRow[] = await aBO.dbContext.findAll(
                            esWB_Power_Metric_Relationship,
                            {
                                where: {
                                    WB_MODEL_POWERMETRIC_ID: powerMetricRow.cif.WB_MODEL_POWERMETRIC_ID,
                                    DELETED_IND: { nin: ["1"] }
                                }
                            }
                        );
                        _.forEach(powerMetricRels, (aPowerMetricRel: WB_PowerMetricRelationshipRow) => {
                            if (aPowerMetricRel.isActive) {
                                if (
                                    !(aPowerMetricRel.cif.WB_MODEL_PREDICTOR_ID in arrCoreVolumePredictors) &&
                                    invalidPowerMetrics.indexOf(powerMetricRow.cif.POWERMETRIC_NAME) == -1
                                ) {
                                    invalidPowerMetrics.push(powerMetricRow.cif.POWERMETRIC_NAME);
                                }
                            }
                        });
                    }
                }
            }

            if (invalidPowerMetrics.length > 0) {
                aBO.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "modelPredictor",
                    title:
                        "Power Metric " +
                        _.toString(invalidPowerMetrics) +
                        " contains predictors that do not exist in the core volume formula. Please select a power metric that has the valid predictors. ",
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }
        }

        // (async () => {
        //     await spendFunctionValidation();
        // })();
        validatePowerMetric();

        const uniqCoeffIds = _.uniqBy(
            aBO?.WB_Model.WB_ModelCannibalizationRelationshipRows,
            (canRelType: WB_ModelCannibalizationRelationshipRow) => {
                return canRelType.cif.WB_MODEL_COEFFICIENT_ID;
            }
        );

        if (aBO?.WB_Model?.WB_ModelCannibalizationRelationshipRows.length != uniqCoeffIds.length) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "duplicateCannTypes",
                title: "Save failed. Please ensure the same cannibalization coefficient is not used for multiple cannibalization types.",
                description: "",
                subtitle: "",
                count: 0
            });
        }
        return;
        // resolve();
        // });
    }

    static ValidateResidualMethod(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            const residualMethod = aBO.WB_Model.cif.RESIDUAL_METHOD;
            const sameOrder = false;
            let sameValue = false;
            const nonObservedValue: { flag: boolean; name: string[] } = { flag: false, name: [] };
            let lastValue: number;
            const decompositionOrderSet = new Set();
            if (residualMethod === "residual") {
                const activeRelationshipRows = _.filter(
                    aBO.WB_Model.WB_ModelVolumeComponentRelationshipRows,
                    (x) => x.isActive
                );

                _.forEach(activeRelationshipRows, (row: WB_ModelVolumeComponentRelationshipRow, idx) => {
                    // if ((row.cif.DECOMPOSITION_ORDER) === lastValue) {
                    //     sameValue = true
                    // }

                    lastValue = _.toNumber(row.cif.DECOMPOSITION_ORDER);
                    decompositionOrderSet.add(lastValue);

                    // For the last volume component BEFORE the 'Residual Volume', all predictors must be set to 'Observed'
                    if (idx === activeRelationshipRows.length - 2) {
                        _.forEach(row.WB_ModelVolumeComponentItemRows, (itemRow: WB_ModelVolumeComponentItemRow) => {
                            const componentName =
                                itemRow.WB_ModelVolumeComponentRelationshipRow.WB_ModelVolumeComponentRow.cif
                                    .VOLUME_COMPONENT_NAME;
                            if (!nonObservedValue.flag && itemRow.cif.VALUE_TYPE !== "self") {
                                nonObservedValue.flag = true;
                                nonObservedValue.name.push(componentName);
                            }
                        });
                    }
                });
                if (activeRelationshipRows.length !== decompositionOrderSet.size) {
                    sameValue = true;
                }
                if (nonObservedValue.flag) {
                    aBO.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "modelPredictor",
                        title: `All 'Parameter Values' should be set to 'Observed Value' for ${nonObservedValue.name.join(
                            ","
                        )}`,
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                } else {
                    aBO.ValidateMessageProvider.removeMessage("modelPredictor");
                }
                // if (sameOrder) {
                //     aBO.ValidateMessageProvider.addMessage(
                //         {
                //             type: MessageType.Error,
                //             code: 'sameOrder',
                //             title: `Current decomposition order is not allowed. Please enter distinct order sequence on the “Volume Decomposition” tab.`,
                //             description: "",
                //             subtitle: "",
                //             count: 0
                //         })
                // }
                // else {
                //     aBO.ValidateMessageProvider.removeMessage('sameOrder');
                // }
                if (sameValue) {
                    aBO.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "sameValue",
                        title: `Duplicate values in 'Decompositon Order' Column is not allowed`,
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                } else {
                    aBO.ValidateMessageProvider.removeMessage("sameValue");
                }
            }
            resolve();
        });
    }

    static ValidateCannibalization(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            const modelRow: WB_ModelRow = aBO.WB_Model;

            const bCann: boolean = modelRow.cif.CANNIBALIZATION_IND == "1" ? true : false;
            if (bCann) {
                const arrCannTypeRel: WB_ModelCannibalizationRelationshipRow[] = _.filter(
                    modelRow.WB_ModelCannibalizationRelationshipRows,
                    (aCannRelRow: WB_ModelCannibalizationRelationshipRow) => aCannRelRow.isActive
                );
                if (arrCannTypeRel.length == 0) {
                    aBO.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "modelCannRel",
                        title: `Missing cannibalization type under the cannibalization tab`,
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                }

                _.forEach(arrCannTypeRel, (aRelRow: WB_ModelCannibalizationRelationshipRow) => {
                    const powerMetric = aRelRow.cif.WB_MODEL_POWERMETRIC_ID;
                    if (powerMetric == 0 || _.isUndefined(powerMetric)) {
                        aBO.ValidateMessageProvider.addMessage({
                            type: MessageType.Error,
                            code: "modelCannRelPowerMetric",
                            title:
                                `Missing Power Metric for ` +
                                aRelRow.WB_ModelCannibalizationTypeRow.cif.CANNIBALIZATION_TYPE_NAME,
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                    }

                    const modelFunction = aRelRow.cif.WB_MODEL_FUNCTION_ID;
                    if (modelFunction == 0 || _.isUndefined(modelFunction)) {
                        aBO.ValidateMessageProvider.addMessage({
                            type: MessageType.Error,
                            code: "modelCannRelModelfunc",
                            title:
                                `Missing Model Function for ` +
                                aRelRow.WB_ModelCannibalizationTypeRow.cif.CANNIBALIZATION_TYPE_NAME,
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                    }
                });
            }
            resolve();
        });
    }

    static ValidateModelFormula(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            const modelRow: WB_ModelRow = aBO.WB_Model;
            const modelTerms = _.map(
                _.filter(
                    modelRow.WB_ModelTermRelationshipRows,
                    (aMTRow: WB_ModelTermRelationshipRow) => aMTRow.isActive
                ),
                (aModelTerm: WB_ModelTermRelationshipRow) => aModelTerm.WB_ModelTermRow.cif.TERM_ID
            );
            let modelPredictorFormula = modelRow.cif.MODEL_FORMULA;

            //remove all spaces
            modelPredictorFormula = modelPredictorFormula.replace(/\s/g, "");

            //replace all math operators with "#"
            modelPredictorFormula = modelPredictorFormula.replace(/[()+\-*/.]/g, "#");

            const arrPredictorsFromFormula = modelPredictorFormula.split("#");
            const keyPredictorFormulaTerms = _.keyBy(arrPredictorsFromFormula, (a) => a);

            for (const aTerm of modelTerms) {
                if (!(aTerm in keyPredictorFormulaTerms)) {
                    aBO.ValidateMessageProvider.addMessage({
                        type: MessageType.Error,
                        code: "modelPredictorFormulaError",
                        title:
                            "Model Term " +
                            aTerm +
                            " has been assigned to the model, but is not used in the Predictive Model Formula.  Please remove the term, or update the formula, as appropriate.",
                        description: "",
                        subtitle: "",
                        count: 0
                    });
                }
            }

            resolve();
        });
    }

    static ValidatePredictorMetaMappings(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve) => {
            const predictors: WB_ModelPredictorRow[] = _.flatMap(
                _.filter(
                    aBO.drWB_Model.WB_ModelPredictorRelationshipRows,
                    (aRow) => aRow.isActive && aRow.WB_ModelPredictorRow.cif.PREDICTOR_META_ID !== ""
                ),
                (aRow) => aRow.WB_ModelPredictorRow
            );
            //only allow one predictor to be mapped to any one predictor meta per model, as long as it's not the "Other" type
            const metaIdToPredictor = _.groupBy(
                predictors,
                (aPredictor: WB_ModelPredictorRow) => aPredictor.cif.PREDICTOR_META_ID
            );
            _.forEach(metaIdToPredictor, (predictors: WB_ModelPredictorRow[], metaId: string) => {
                if (predictors.length <= 1) {
                    return;
                }

                aBO.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "modelPredictorMetaTypeError",
                    title: `Predictors ${_.join(
                        _.map(predictors, (x) => x.cif.MODEL_PREDICTOR_ID),
                        ", "
                    )} are mapped to meta type ${metaId}. Please confirm only one predictor is mapped to a meta type per model`,
                    description: "",
                    subtitle: "",
                    count: 0
                });
            });
            resolve();
        });
    }

    static ValidatePredictorGroups(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve) => {
            const profiles: WB_ModelProfileRow[] = _.filter(
                aBO.WB_Model.WB_ModelProfileRows,
                (aRow: WB_ModelProfileRow) => aRow.isActive
            );
            _.forEach(profiles, (aProfile: WB_ModelProfileRow) => {
                const groups: WB_ModelProfileGroupRow[] = _.filter(
                    aProfile.WB_ModelProfileGroupRows,
                    (aRow: WB_ModelProfileGroupRow) => aRow.isActive && aRow.bIsRangeGroup
                );
                _.forEach(groups, (aGroup: WB_ModelProfileGroupRow) => {
                    const predictors: WB_ModelProfileGroupPredictorRow[] = _.filter(
                        aGroup.WB_ModelProfileGroupPredictorRows,
                        (aRow: WB_ModelProfileGroupPredictorRow) => aRow.isActive
                    );
                    if (predictors.length > 1) {
                        aBO.ValidateMessageProvider.addMessage({
                            type: MessageType.Error,
                            code: "modelPredictorGroupError",
                            title: `Only one predictor can be assigned to Group - ${aGroup.cif.GROUP_NAME} (Profile - ${aProfile.cif.PROFILE_NAME} )  group because the Widget Type is Range Generator.`,
                            description: "",
                            subtitle: "",
                            count: 0
                        });
                    }
                });
            });
            resolve();
        });
    }

    static ValidateModelProfiles(aBO: ModelBO): Promise<void> {
        return new Promise<void>((resolve) => {
            const emptyProfileName: WB_ModelProfileRow[] = _.filter(
                aBO.drWB_Model.WB_ModelProfileRows,
                (aRow) => aRow.isActive && aRow.cif.PROFILE_NAME == ""
            );
            if (!_.isEmpty(emptyProfileName)) {
                aBO.ValidateMessageProvider.addMessage({
                    type: MessageType.Error,
                    code: "modelProfileName",
                    title: `Profile Name cannot be empty`,
                    description: "",
                    subtitle: "",
                    count: 0
                });
            }

            resolve();
        });
    }
}
